import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonType } from '../../enum/button-type.enum';
import { MatIcon } from '@angular/material/icon';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-button',
  imports: [MatIcon],
  templateUrl: './button.component.html',
  standalone: true,
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  type = input<ButtonType>(ButtonType.primary);
  size = input<InputSize>(InputSize.large);
  leadingIconName = input<string | null | undefined>();
  trailingIconName = input<string | null | undefined>();
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  submit = input<boolean>(false);
  fullWidth = input<boolean>(false);
  buttonClick = output<void>();
  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;
}
